export const YEARLY_DUE_DATE = "hoaYearlyDueDate";
export const MONTHLY_DUE_DATE = "hoaMonthlyDueDate";
export const LEASE_DUE_DATE = "hoaLeaseAdminDueDate";
export const CURRENCY = "currency";
export const BANK_NAME = "bankName";
export const ROUTING_NUMBER = "bankRoutingNumber";
export const ACCOUNT_NUMBER = "bankAccountNumber";
export const PHONE_1 = "zellePhone1";
export const PHONE_2 = "zellePhone2";
export const REPORTING_LEVEL = "distributionLevel";
export const DISTRIBUTION_MODE = "distributionMode";
export const FREQUENCY_FOR_ACTUALS = "actualsFrequency";
export const ACTUALS_DAY_OF_MONTH = "actualsDayOfMonth";
export const ACTUALS_DATE = "actualsDate";
export const ACTUALS_DATE_Q1 = "actualsDateQ1";
export const ACTUALS_DATE_Q2 = "actualsDateQ2";
export const ACTUALS_DATE_Q3 = "actualsDateQ3";
export const ACTUALS_DATE_Q4 = "actualsDateQ4";

export const MONTHLY = "MONTHLY";
export const QUARTERLY = "QUARTERLY";
export const YEARLY = "YEARLY";
export const ADHOC = "ADHOC";
export const ACTUAL_ONLY = "ACTUAL_ONLY";
export const PLAN_ONLY = "PLAN_ONLY";
export const PLAN_AND_ACTUAL = "PLAN_AND_ACTUAL";
export const NONE = "NONE";

export const distributionModeOptions = [
  { label: "None", value: NONE },
  { label: "Actual Only", value: ACTUAL_ONLY },
  { label: "Plan Only", value: PLAN_ONLY },
  { label: "Plan + Actual", value: PLAN_AND_ACTUAL },
];

export const frequencyForActualsOptions = [
  { label: "Adhoc", value: ADHOC },
  { label: "Monthly", value: MONTHLY },
  { label: "Quarterly", value: QUARTERLY },
  { label: "Yearly", value: YEARLY },
];

export const actualsScheduleFields = [
  ACTUALS_DAY_OF_MONTH,
  ACTUALS_DATE,
  ACTUALS_DATE_Q1,
  ACTUALS_DATE_Q2,
  ACTUALS_DATE_Q3,
  ACTUALS_DATE_Q4,
];

export const quarterlyDateFields = [
  ACTUALS_DATE_Q1,
  ACTUALS_DATE_Q2,
  ACTUALS_DATE_Q3,
  ACTUALS_DATE_Q4,
];
